// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getSalesStatus: { data: null },
  createUpdateSaleStatus: { data: null },
  updateSaleStatusStatus: { data: null },
  deleteSalesStatus: { data: null },
  addUpdateSaleRemarksStatus: { data: null },
  deleteSaleRemarksStatus: { data: null },
  getSaleByIdStatus: { data: null },
  getBillingTransactionsDetailsStatus: { data: null },
  refundBillingTransactionsStatus: { data: null },
  editCompanySubscriptionStatus: { data: null },
  getCompanySubscriptionDetailsStatus: { data: null },
};
